import PRODUCT_IMAGES from "../config/productImages";
import CATEGORY_IMAGES from "../config/categoryImages";

/**
 * Image d'un lot : photo du produit, sinon image de sa sous-catégorie, puis de sa
 * catégorie, sinon l'image par défaut.
 */
const getProductImage = (productName, subCategoryName, categoryName) => {

    const normalizedProduct = productName
        ? productName.toUpperCase().replace(/\s+/g, "_")
        : null;

    return (
        (normalizedProduct && PRODUCT_IMAGES[normalizedProduct]) ||
        CATEGORY_IMAGES[subCategoryName] ||
        CATEGORY_IMAGES[categoryName] ||
        PRODUCT_IMAGES.DEFAULT
    );
};

/** onError d'une <img> : image par défaut, une seule fois (pas de boucle si elle manquait aussi). */
export const fallbackToDefaultImage = (event) => {
    event.currentTarget.onerror = null;
    event.currentTarget.src = PRODUCT_IMAGES.DEFAULT;
};

export default getProductImage;
